import React from 'react'

function cashandbooks() {
  return (
    <div>
      <h1>CAS Handbooks</h1>
    </div>
  )
}

export default cashandbooks
